import * as actions from './actions';
import { ActionType, createReducer } from 'typesafe-actions';
import { SdkState } from './types';

const initialState: SdkState = {
  availableCmds: [],
  isNativeHeaderHidden: false,
};

const setAvailableCmdsHandler = (
  state: SdkState,
  { payload }: ActionType<typeof actions.setAvailableCmds>,
): SdkState => ({
  ...state,
  availableCmds: payload,
});

const hideNativeHeaderHandler = (state: SdkState): SdkState => ({
  ...state,
  isNativeHeaderHidden: true,
});

const sdkReducer = createReducer(initialState)
  .handleAction(actions.setAvailableCmds, setAvailableCmdsHandler)
  .handleAction(actions.hideNativeHeader, hideNativeHeaderHandler);

export default sdkReducer;
